import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Spin } from 'antd';
import axios from 'axios';
import store from '../store';

export default function PermissionSession({ children }) {
  const token = useSelector(state => state.token);
  const dispatch = useDispatch();
  const [readyToken, setReadyToken] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!token) return undefined;
    let active = true;
    let pending = false;
    const refresh = async () => {
      if (pending) return;
      pending = true;
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/account/verify`);
        if (!active) return;
        if (JSON.stringify(store.getState().user) !== JSON.stringify(data.user)) dispatch({ type: 'REFRESH_USER', payload: data.user });
        setReadyToken(token);
        setFailed(false);
      } catch (error) {
        if (!active) return;
        if (error.response?.status === 401) dispatch({ type: 'LOGOUT' });
        else setFailed(true);
      } finally { pending = false; }
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    window.addEventListener('focus', refresh);
    window.addEventListener('permissions-refresh', refresh);
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', refresh); window.removeEventListener('permissions-refresh', refresh); };
  }, [token, dispatch]);
  if (token && readyToken !== token) return <div style={{ padding: 40 }}>{failed
    ? <Alert type="error" message="Impossible de charger les permissions. Réessayez en rechargeant la page." />
    : <Spin tip="Chargement des permissions…" />}</div>;
  return children;
}
